export default __webpack_public_path__ + "static/media/icn_link.3e94f018.svg";